import { render, staticRenderFns } from "./reg-3.vue?vue&type=template&id=048b8994&lang=pug&"
import script from "./reg-3.vue?vue&type=script&lang=js&"
export * from "./reg-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports